import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from 'src/app/shared/models/types/selectable.type';
import { SharedQueries } from 'src/app/models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from 'src/app/models/shared/types/page-info.type';
import { Category } from 'src/app/models/common/category.model';

@Injectable({
  providedIn: 'root'
})
export class CategoryFilterService extends IFilterListService<Category> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    const query = variables.brandIds.length ? SharedQueries.GET_CATEGORIES_NO_IDS : SharedQueries.GET_CATEGORIES_ALL
    const filters = { search: searchText, companyId: this.appService.companyId, first: variables.first, after: searchText ? null : this.pageInfo.endCursor };
    if (variables.brandIds.length) filters['brandIds'] = variables.brandIds;
    this.graphQlService.getData<Category>(query, filters)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['category'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<Category>) => {
          let datasource: Array<Selectable<Category>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
